module.exports = __webpack_public_path__ + "static/media/Panther871_2c.0579a74d.svg";